import React, { useEffect, useState, useCallback, lazy, Suspense } from 'react';
import { View, Text, StyleSheet, Platform, ActivityIndicator, ScrollView } from 'react-native';
import CommonPage from '../components/CommonPage';
import { fetchHoroscope } from '../services/apiCall';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';

let LoaderKit;
if (Platform.OS === 'android' || Platform.OS === 'ios') {
  LoaderKit = lazy(() => import('react-native-loader-kit'));
}

let ToastAndroid;
if (Platform.OS === 'android' || Platform.OS === 'ios') {
  ToastAndroid = lazy(() => import('react-native'));
}

const Horoscope = () => {
  const [horoscope, setHoroscope] = useState(null);
  const [zodiacSign, setZodiacSign] = useState('');
  const [loading, setLoading] = useState(true);
  const [balfetching,setbalanceFetching]=useState(false);
  const [userBalance,setUserBalance] = useState(null);
  const navigation =useNavigation();


  const getUserBalance = async () => {
    setbalanceFetching(true)
    const userData = await AsyncStorage.getItem('user');
    if (userData) {
      const parsedData = JSON.parse(userData);
      setUserBalance(parsedData?.userBalance);
      setbalanceFetching(false)
    }
  };
  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      getUserBalance();
    });
    return unsubscribe;
  }, [navigation]);
  useEffect(() => {
    const getHoroscope = async () => {
      setLoading(true);
      try {
        const response = await fetchHoroscope();
        setHoroscope(response?.data?.data);
        if (response?.data?.zodiac) {
          setZodiacSign(response?.data?.zodiac);
        }
      } catch (error) {
        ToastAndroid.show('Failed, Fetching horoscope', ToastAndroid.SHORT);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    getHoroscope();
  }, []);

  const renderLoader = () => {

    if (Platform.OS === 'android' || Platform.OS === 'ios') {
      return (
        <Suspense fallback={<ActivityIndicator size="large" color="#f0df21" style={{ alignSelf: 'center' }} />}>
          <LoaderKit
            style={{ width: 50, height: 50, alignSelf: 'center' }}
            name={'BallPulse'}
            color={'#f0df21'}
          />
        </Suspense>
      );
    } else {
      return (
        <ActivityIndicator
          size="large"
          color="#f0df21"
          style={{ alignSelf: 'center' }}
        />
      );
    }
  };


  const HoroscopeComponent = () => {
    return (
      loading ? (
        <View style={styles.loaderContainer}>
         {renderLoader()}
        </View>
      ) : (
        <ScrollView style={styles.HoroscopeContainer} contentContainerStyle={{ flexGrow: 1 }}>
          <Text style={styles.title}>{'Your Zodiac Sign'}</Text>
          <Text style={styles.zodiacSign}>{zodiacSign}</Text>
          <Text style={styles.title}>{"Today's Horoscope"}</Text>
          <Text style={styles.horoscopeText}>{horoscope}</Text>
        </ScrollView>
      )
    );
  };

  return (
    <View style={styles.container}>
      <CommonPage userBalance={userBalance} balfetching={balfetching}>
        {HoroscopeComponent()}
      </CommonPage>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  loaderContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  HoroscopeContainer: {
    padding: 30,
  },
  title: {
    fontSize: 20,
    fontWeight: '500',
  },
  zodiacSign: {
    fontSize: 20,
    fontWeight: '300',
    width: '100%',
    backgroundColor: '#fff',
    marginTop: 5,
    paddingLeft: 10,
    paddingVertical: 10,
    borderRadius: 10,
  },
  horoscopeText: {
    fontSize: 20,
    fontWeight: '300',
    width: '100%',
    backgroundColor: '#fff',
    marginTop: 5,
    paddingHorizontal: 10,
    paddingVertical: 10,
    borderRadius: 10,
    textAlign: 'justify',
    marginBottom:60
  },
});

export default Horoscope;
